
import ApiRequest from "./ApiRequest";

interface IParamType {
}

class AxiosListDokumen extends ApiRequest<IParamType> {
    constructor() {
        super("/list_dokumen");
    }

    get(id_pegawai: number, token: string) {
        this.path += `?id_pegawai=${id_pegawai}`;
        return this.get_request(token);
    }
}

export default AxiosListDokumen;
